export const config = {
  fieldControl: false,
  searchTypeWidth: 150, // 搜索框宽度
  search: [
    {
      label: '适用产品',
      name: 'productNameKey',
      labelProps: {
        width: 120,
      },
    },
    {
      label: '适用门店',
      name: 'orgId',
      itemType: 'select',
      data: 'companyList',
      labelKey: 'name',
      key: 'id',
    },
    {
      label: '适用角色',
      name: 'roleId',
      itemType: 'select',
      data: 'roleList',
      labelKey: 'name',
      key: 'id',
    },
  ],
  columns: [
    { title: '适用产品', dataIndex: 'productName', width: 120 },
    { title: '适用门店', dataIndex: 'orgName', width: 120 },
    { title: '适用角色', dataIndex: 'roleName', width: 120 },
    { title: '优惠大类', dataIndex: 'discountTypeName', width: 120 },
    { title: '优惠小类', dataIndex: 'discountSubcategoryTypeName', width: 120 },
    { title: '值', dataIndex: 'ratioVal', width: 80 },
    { title: '开始日期', dataIndex: 'startDate', width: 120, itemType: 'date' },
    { title: '结束日期', dataIndex: 'endDate', width: 120, itemType: 'date' },
    { title: '操作', dataIndex: '#', width: 120, fixed: 'right', render: 'actionRender' },
  ],
  footer: [
    { label: '下载', render: 'exportRender' },
    { label: '导入', render: 'importRender' },
    { label: '新增配置', type: 'primary', events: ['onClick:onAdd'] },
  ],
  batchActions: [{ label: '批量删除', danger: true, events: ['onClick:onBatchDelete'] }],
}
